import Config from "./app.config";

const headers = {
  "Content-Type": "application/json; charset=utf-8",
  Accept: "application/json; charset=utf-8",
};

const configs = {
  production: {
    baseURL: "https://vlab-generator.onrender.com/api",
    headers,
  },
  development: {
    baseURL: "https://vlab-generator.onrender.com/api",
    headers,
  },
};

export default Object.freeze(configs[Config.mode]);
